import React, { useState, useEffect } from "react";
import Header from "./sections/Header";
import ChatBot from "./components/ChatBot";
import Hero from "./sections/Hero";
import TechStack from "./sections/TechStack";
import Solutions from "./sections/Solutions";
import Projects from "./sections/Projects";
import Contacts from "./sections/Contacts";
import Pricing from "./sections/Pricing"; // Импорт уже на месте!

function App() {
  // Состояние для управления открытием чата из других компонентов (например, из Hero)
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Устанавливаем заголовок страницы при загрузке
  useEffect(() => {
    document.title = "ОТРА-М | ИТ-решения и безопасность на транспорте";
  }, []);

  return (
    <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900">
      {/* Навигация (Хедер) */}
      <Header />

      <main>
        {/* Главный экран: передаем функцию открытия чата в кнопку "Обсудить проект" */}
        <Hero onOpenChat={() => setIsChatOpen(true)} />

        {/* Бегущая строка с технологиями (Linux, Nginx, React и т.д.) */}
        <TechStack />

        {/* Блок компетенций: Техподдержка, ИБ, Автоматизация */}
        <Solutions />

        {/* ВСТАВИЛИ СЕКЦИЮ СЮДА: Каталог услуг и цены */}
        <Pricing />

        {/* Реализованные кейсы на ж/д транспорте */}
        <Projects />

        {/* Контакты, реквизиты и интерактивная карта */}
        <Contacts />
      </main>

      {/* Подвал (можно добавить позже или оставить контакты финальной точкой) */}
      <footer className="py-8 bg-slate-50 border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-slate-400 text-xs font-medium uppercase tracking-widest">
            © {new Date().getFullYear()} ООО "ОТРА-М". Все права защищены.
            ИТ-аккредитация №68290.
          </p>
        </div>
      </footer>

      {/* Чат-бот: принимает состояние из Hero и позволяет закрывать себя */}
      <ChatBot isOpenExternal={isChatOpen} setIsOpenExternal={setIsChatOpen} />
    </div>
  );
}

export default App;
